import { put, select, takeLatest } from 'redux-saga/effects'

import { SET_ACTIVE_FLOOR, setActiveFloor } from '../../../actions/drawable'
import { DocumentMapping } from '../../../models/documentMapping'
import { Project } from '../../../models/project'
import { PROJECT_PAGE_TAB_VALUES } from '../../../shared/constants/project-settings-names'
import { selectCurrentOverlayChunkIds, setEstimatedOptionOverlayChunkId, setOverlayChunkId } from '../../slices/2D'
import { selectDocumentMappings } from '../../slices/documents'
import {
    updateConflictResolutionFlag,
    updateOverlaidChunkLockedFlag,
    updateReviewingConflictsFlag,
} from '../../slices/masterSetPlan'
import { setActiveTabOnProjectPage } from '../../slices/navigation'
import { selectProject } from '../../slices/project'

export function* handleResetActiveOverlayOnPageChange(
    triggerAction: ReturnType<typeof setActiveTabOnProjectPage> | ReturnType<typeof setActiveFloor>
) {
    const project: Project | null = yield select(selectProject)

    // We do not want to reset the overlays for non master
    // set projects
    if (project && !project.is_master_set) return

    // Short circuit if changing tab to digitizer
    if (
        triggerAction.type === 'navigation/setActiveTabOnProjectPage' &&
        triggerAction.payload === PROJECT_PAGE_TAB_VALUES['DIGITIZER']
    ) {
        return
    }

    const overlayChunkIds: number[] = yield select(selectCurrentOverlayChunkIds)

    const documentMappings: DocumentMapping[] | null = yield select(selectDocumentMappings)

    if (!documentMappings) return

    const isAnyOverlaidMappingAnOption = documentMappings.some(
        (mapping) => overlayChunkIds.includes(mapping.document_chunk_id) && mapping.is_option
    )

    yield put(setOverlayChunkId(null))
    yield put(setEstimatedOptionOverlayChunkId({ opt: null }))

    if (isAnyOverlaidMappingAnOption) {
        yield put(updateConflictResolutionFlag(false))
        yield put(updateOverlaidChunkLockedFlag(false))
        yield put(updateReviewingConflictsFlag(false))
    }
}

export function* watchForPageChangeAndResetOverlay() {
    // Watches for change of plan page
    yield takeLatest(SET_ACTIVE_FLOOR, handleResetActiveOverlayOnPageChange)
    // Watches for tab change to Digitizer
    yield takeLatest(setActiveTabOnProjectPage, handleResetActiveOverlayOnPageChange)
}
